import React from "react";
import { injectIntl } from "react-intl";
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import { api, categoryUploadDir } from "../../../config";

import defaultServiceProviderExitTickIcon from '/public/Icons/defaultServiceProviderExitTickIcon.svg';

import s from './ManageCategoryItem.css';

const ManageCategoryItem = ({ categoryName, logoImage, isSelected }) => {
    return (
        <>
            <span className={cx(s.manageServiceCardImgContainer, 'manageServiceCardImgContainerRtl')}>
                <span className={s.manageServiceCardImgWrapper}>
                    <img src={`${api.apiEndpoint}${categoryUploadDir}medium_${logoImage}`} height={200} width={200} className={s.manageServiceCardImg} />
                </span>
                {isSelected && <span className={cx(s.manageServiceCardSelectIcon, 'manageServiceCardSelectIconRtl')}>
                    <img src={defaultServiceProviderExitTickIcon} alt="defaultServiceProviderExitTickIcon" />
                </span>}
            </span>
            <span className={s.manageServiceCardInfo}>
                {categoryName}
            </span>
        </>
    )
}
export default injectIntl(withStyles(s)(ManageCategoryItem));

